<template>
  <div class="app-container">
    <div style="margin-bottom:20px" class="grid-content bg-purple">
      <el-button @click="handleCreate()" type="primary" size="mini" plain>新增一级部门</el-button>
    </div>

    <tree-table :height="contentStyleObj" :header-cell-style="{background: '#eee',color:'#333','font-size': '13px'}" @getlist=init2 :data="data" :columns="columns" border/>
    <!-- 弹框 -->
    <el-dialog destroy-on-close :title="textMap[dialogStatus]" v-model="dialogFormVisible" :close-on-click-modal="false" class="button_bg">
      <el-form ref="dataForm" :model="temp" label-position="right" label-width="100px">
        <div class="common_dialog_box clearfix">
          <div class="item_one clearfix">
            <el-form-item label="部门名称" class="item">
              <el-input v-model="temp.name" placeholder="请输入部门名称" style="width:100%;" size="mini" ></el-input>
            </el-form-item>
            <el-form-item label="部门人员默认角色" class="item" label-width="130px">
              <el-select v-model="temp.defaultRoleId" placeholder="选择角色" size="mini">
                <el-option v-for="item in roleLlist" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="item_one clearfix">
            <el-form-item label="备 注" class="item">
              <el-input v-model="temp.remark"  style="width:100%;" size="mini" ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="mini">取消</el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()" size="mini">确定</el-button>
      </div>
      </template>
    </el-dialog>
    <!-- 弹框 -->

  </div>
</template>

<script>
import treeTable from '@/components/TreeTable'
import { getBaseDepts, saveBaseDept, getSysRoles } from '@/api/sys.js'
export default {
  name: 'user-dep',
  components: { treeTable },
  data() {
    return {
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '修改',
        create: '新增'
      },
      roleLlist: [],
      temp: {},
      columns: [
        {
          text: '部门名称',
          value: 'label',
          width: 200
        },
        {
          text: '部门主管',
          value: 'leaders',
          width: 200
        },
        {
          text: '部门人员默认角色',
          value: 'defaultRoleName',
          width: 200
        },
        {
          text: '部门人数',
          value: 'userNum'
        },{
          text: '部门所有人数',
          value: 'allUserNum'
        },
        {
          text: '备注',
          value: 'remark'
        },
      ],
      data: [],
      contentStyleObj:{}, //高度变化
    }
  },
  created() {
    this.contentStyleObj=this.$getHeight(220)
    window.addEventListener('resize', this.getHeight);
    this.init()
    this.initBus()
  },
  methods: {
    initBus(){
      this.$bus.off("personUpdate")
      this.$bus.on("personUpdate", (val) => {
        this.init()
      });
      this.$bus.off("addUpdate")
      this.$bus.on("addUpdate", (val) => {
        this.init()
      });
    },
    init(){
      this.getDepts()
      this.getRoles()
    },
    getRoles() {
      this.listLoading = true
      getSysRoles({}).then(response => {
        this.roleLlist = response.data.data.list
        this.roleId = response.data.data.list[0].id
      })
    },
    resetTemp() {
      this.temp = {
        name: '',
        parentId: '',
      }
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.temp.parentId =  this.id*1
          console.log('this.temp:', this.temp)
          saveBaseDept(this.temp).then((res) => {
            // this.list.push(this.temp)
            if(res.data.msg != "success"){
              return
            }
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: '创建成功'
            });
            this.getDepts()
            this.$store.dispatch("delCachedViewByName", "user-user"); //清除"人员管理"页面缓存
          })
        }
      })
    },
    handleUpdate(row) {
      this.temp = Object.assign({}, row) // copy obj
      this.temp.dep = arr
      console.log(arr)
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp)
          this.temp.parentId =  this.id*1
          // this.temp.deptPosition = this.temp.dep.join('-')
          saveBaseDept(tempData).then((res) => {
            this.$store.dispatch("delCachedViewByName", "user-user"); //清除"人员管理"页面缓存
            if(res.data.msg != "success"){
              return
            }
            this.getDepts()
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    init2() {
      this.getDepts()
    },
    getDepts() {
      getBaseDepts({}).then(res => {
        let big = res.data.data.list[0]
        console.log(res.data.data.list[0])
        this.id = big.id
        this.data = big.children
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.item_one {
  display: flex;
}
</style>